<template>
     <Teleport to="#app">
        <input type="checkbox" id="edit-modal" class="modal-toggle" />
        <div class="modal">
            <div class="modal-box bg-base-300">
                <h3 class="font-bold text-lg">{{ __('Edit') + ' ' + (update.name || __('Product')) }}</h3>
                <Form @submit="submit" class="h-full flex flex-col mt-4" v-slot="{ errors }">
                    <div>
                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium mt-3" for="">
                            {{ __('sales price') }}
                        </label>
                        <Field type="number" name="sale_price" :class="{ 'input-error': errors.sale_price }" class="input"
                            v-model="update.sale_price" />
                    </div>
                    <div>
                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium mt-3" for="">
                            {{ __('Count') }}
                        </label>
                        <Field name="quantity" type="number" :class="{ 'input-error': errors.quantity }" class="input"
                            v-model="update.quantity" />
                    </div>
                    <div>
                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium mt-3" for="">
                            {{ __('Discount type') }}
                        </label>
                        <Field as="select" select name="discount_type" :class="{ 'select-error': errors.discount_type }"
                            class="select" v-model="update.discount_type">
                            <option value="percent">{{ __('Percent') }}</option>
                            <option value="amount">{{ __('Amount') }}</option>
                        </Field>
                    </div>
                    <div>
                        <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium mt-3" for="">
                            {{ __('Discount') }}
                        </label>
                        <Field type="number" step="0.01" name="discount" :class="{ 'input-error': errors.discount }" class="input"
                            v-model="update.discount" />
                    </div>
                    <div class="modal-action">
                        <label for="edit-modal" class="btn btn-sm">{{ __('Refuse')
                            }}</label>
                        <button type="submit" class="btn btn-sm btn-info !ml-0 !mr-2">
                            {{ __('Edit') }}
                        </button>
                    </div>
                </Form>
            </div>
        </div>
    </Teleport>
</template>
<script setup>
import { Field, Form } from "vee-validate";
const update = reactive({});
const props = defineProps(['product']);
const emit = defineEmits(['updateItem']);
Object.assign(update,props.product);
const submit = () => emit('updateItem',update);
</script>